<template>
    <div class="home-content" v-html="htmlContent"></div>
</template>

<script lang="ts">
import { v4 as uuidV4 } from "uuid";
import { setPoster } from "@/services/PosterGenerator";
export default {
    name: "HomeContentClassic",
    emits: ["report-btn-clicked"],
    props: {
        videoUrl: {
            type: String,
            default: ""
        },
        adminUrl: {
            type: String,
            default: ""
        },
        displayRecordButton: Boolean,
        displayTextResponseButton: Boolean,
        displayEditButton: Boolean,
        displayShareButton: Boolean,
        displayDownloadButton: Boolean,
        displayReportButton: {
            type: Boolean,
            default: true
        },
        goToRecord: {
            type: Function,
            required: true
        },
        onVideoPick: {
            type: Function,
            required: true
        },
        openReplyVideoModal: {
            type: Function,
            required: true
        },
        share: {
            type: Function,
            required: true
        },
        downloadVideo: {
            type: Function,
            required: true
        },
        htmlContent: {
            type: String,
            default: ""
        },
        jsContent: {
            type: Array
        },
        contentBanned: {
            type: Boolean,
            default: false
        },
        webarUrl: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            fullscreenEnabled: false,
            videoReady: false,
            isPlayingVideo: false,
            domElements: {},
            jsDom: [],
            reportMessageUuid: uuidV4(),
            poster: ""
        };
    },
    mounted() {
        console.log("CUSTOPM");
        if (this.jsContent.length) {
            this.jsContent.forEach(js => {
                const script = document.createElement("script");
                script.type = "text/javascript";

                if (js.substr(0, 4) === "http") {
                    script.src = js;
                } else {
                    script.innerHTML = js;
                }
                document.head.appendChild(script);
            });
        }
        this.onDOMMounted();
        this.updateProfileLink();
        this.updateVideoContainer();
        this.updateVideo();
        this.updatePlayButton();
        this.updateRecordButtons();
        this.updateShareButton();
        this.updateDownloadButton();
        this.observerFs();
    },
    beforeUnmount() {
        this.jsDom.forEach(scriptTag => {
            scriptTag.parent.removeChild(scriptTag);
        });
    },
    methods: {
        goFullScreen() {
            /**
             * Fullscreen DOM management is done directly on the custom HTML / JS.
             * Here we just update the component data to update other DOM elements.
             */

            // const videoContainer = this.domElements.videoContainer;
            // if (videoContainer) {
            //     const boundingBox = videoContainer.getBoundingClientRect();
            //     videoContainer.style.transform = `translateY(${-boundingBox.y}px) translateX(${-boundingBox.x}px)`;
            // }
            this.fullscreenEnabled = true;
            this.hideElement(this.domElements.arButton)
            document.body.style.overflow='hidden';
        },
        exitFullScreen() {
            this.showElement(this.domElements.arButton)
            document.body.style.overflow='auto';
            /**
             * Fullscreen DOM management is done directly on the custom HTML / JS.
             * Here we just update the component data to update other DOM elements.
             */

            // const videoContainer = this.domElements.videoContainer;
            // if (videoContainer) {
            //     videoContainer.style.transform = `none`;
            // }
            this.fullscreenEnabled = false;
        },
        onVideoPlay() {
            this.isPlayingVideo = true;
        },
        onVideoStop() {
            this.isPlayingVideo = false;
        },
        togglePlay() {
            const homeVideo = document.getElementById("home-video") as HTMLVideoElement;
            if (!homeVideo) {
                return;
            }

            if (this.isPlayingVideo) {
                homeVideo.pause();
            } else {
                homeVideo.play();
            }
        },
        showElement(elt) {
            if (elt) {
                elt.style.removeProperty("display");
            }
        },
        hideElement(elt: HTMLElement) {
            if (elt) {
                elt.style.display = "none";
            }
        },
        observerFs(){
            const target = document.getElementById("home-content");
            const config = {
                attributes: true,
                childList: true,
                subtree: true,
            };

            // Callback function to execute when mutations are observed
            const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === "attributes" && mutation.attributeName === 'class') {
                    if(mutation.target.classList.contains("fullscreen")){
                       window.scrollTo(0, 0); 
                    }
                }
            }
            };
            const observer = new MutationObserver(callback);
            observer.observe(target, config);
        },
        // make refs & store initial style values which can be changed after
        onDOMMounted() {
            this.domElements.profileLink = document.getElementById("profile-link");
            this.domElements.videoContainer = document.getElementById("video-container");
            this.domElements.videoHome = document.getElementById("home-video");
            this.domElements.playButton = document.getElementById("play-button");
            this.domElements.replyVideoButton = document.getElementById("reply-video-button");
            this.domElements.recordVideoButton = document.getElementById("record-video-button");
            this.domElements.inputVideoFile = document.getElementById("videoPick");
            this.domElements.editVideoButton = document.getElementById("edit-video-button");
            this.domElements.inputEditVideoFile = document.getElementById("editVideoPick");
            this.domElements.shareButton = document.getElementById("share-button");
            this.domElements.enterFullscreenBtn = document.getElementById("icon-fullscreen");
            this.domElements.exitFullscreenBtn = document.getElementById("icon-fullscreen-exit");
            this.domElements.arButton = document.getElementById("ar-button");
            this.domElements.downloadButton = document.getElementById("download-button");
            this.domElements.fullscreenDownloadButton = document.getElementById(
                "fullscreen-download-button"
            );
            this.domElements.reportButton = document.getElementById("report-btn");
            this.domElements.arButton = document.getElementById("ar-button");

            this.manageRetroCompatibility();

            if (this.domElements.enterFullscreenBtn) {
                if (!this.videoUrl.length) {
                    this.hideElement(this.domElements.enterFullscreenBtn);
                } else {
                    this.domElements.enterFullscreenBtn.addEventListener(
                        "click",
                        this.goFullScreen
                    );
                }
            }
            if(this.webarUrl && this.domElements.arButton){
                this.domElements.arButton.addEventListener("click",()=>{
                    const link = document.createElement('a');
                    link.href = this.webarUrl;
                    link.target = "_top";
                    link.click();
                });
            }

            this.updateARButton();

            if (this.domElements.exitFullscreenBtn) {
                if (!this.videoUrl.length) {
                    this.hideElement(this.domElements.exitFullscreenBtn);
                } else {
                    this.domElements.exitFullscreenBtn.addEventListener(
                        "click",
                        this.exitFullScreen
                    );
                }
            }

            if (this.domElements.inputVideoFile) {
                this.domElements.inputVideoFile.addEventListener("change", this.onVideoPick);
            }

            if (this.domElements.inputEditVideoFile) {
                this.domElements.inputEditVideoFile.addEventListener("change", this.onVideoPick);
            }

            if (this.domElements.replyVideoButton && !this.displayRecordButton) {
                this.hideElement(this.domElements.recordVideoButton);
                this.domElements.replyVideoButton.addEventListener(
                    "click",
                    this.openReplyVideoModal
                );
            }

            this.updateContentBannedMessage();
            this.updateReportButton();
        },
        updateProfileLink() {
            const profileLink = this.domElements.profileLink;
            if (profileLink) {
                profileLink.setAttribute("target", "_blank");
                profileLink.setAttribute("href", this.adminUrl);
            }
        },
        updateVideoContainer() {
            const videoContainer = this.domElements.videoContainer;
            if (!videoContainer) {
                return;
            }

            this.videoReady || this.contentBanned
                ? this.showElement(videoContainer)
                : this.hideElement(videoContainer);

            if (this.fullscreenEnabled && !videoContainer.classList.contains("fullscreen")) {
                videoContainer.classList.add("fullscreen");
            } else if (!this.fullscreenEnabled && videoContainer.classList.contains("fullscreen")) {
                videoContainer.classList.remove("fullscreen");
            }
        },
        async updateVideo() {
            const videoHome = this.domElements.videoHome;
            if (this.videoUrl.length && videoHome) {
                videoHome.onloadedmetadata = videoHome.oncanplay = () => {
                    this.videoReady = true;
                };
                videoHome.removeEventListener("play", this.onVideoPlay);
                videoHome.removeEventListener("pause", this.onVideoStop);

                videoHome.addEventListener("play", this.onVideoPlay);
                videoHome.addEventListener("pause", this.onVideoStop);
                videoHome.onclick = this.togglePlay;

                videoHome.setAttribute("src", this.videoUrl);
                videoHome.setAttribute("preload", "metadata");
                this.poster = await setPoster(videoHome);
            }
        },

        updateContentBannedMessage() {
            if (this.contentBanned) {
                const videoContainer = this.domElements.videoContainer;
                let contentBannedMessage = document.getElementById(this.reportMessageUuid);

                if (!contentBannedMessage) {
                    contentBannedMessage = document.createElement("div");
                    contentBannedMessage.setAttribute("id", this.reportMessageUuid);
                    contentBannedMessage.innerText = this.$t("report.bannedVideoMessage");

                    contentBannedMessage.style.setProperty("position", "absolute", "important");
                    contentBannedMessage.style.setProperty("top", "0", "important");
                    contentBannedMessage.style.setProperty("left", "0", "important");
                    contentBannedMessage.style.setProperty(
                        "width",
                        "calc(100% - 20px)",
                        "important"
                    );
                    contentBannedMessage.style.setProperty(
                        "height",
                        "calc(100% - 20px)",
                        "important"
                    );
                    contentBannedMessage.style.setProperty("background", "black", "important");
                    contentBannedMessage.style.setProperty("color", "white", "important");
                    contentBannedMessage.style.setProperty("display", "flex", "important");
                    contentBannedMessage.style.setProperty("flex-direction", "column", "important");
                    contentBannedMessage.style.setProperty(
                        "justify-content",
                        "center",
                        "important"
                    );
                    contentBannedMessage.style.setProperty("align-items", "center", "important");
                    contentBannedMessage.style.setProperty("border-radius", "15px", "important");
                    contentBannedMessage.style.setProperty("padding", "10px", "important");
                    contentBannedMessage.style.setProperty("z-index", "999999", "important");

                    if (videoContainer) {
                        videoContainer.appendChild(contentBannedMessage);
                    } else {
                        document.getElementById("app").appendChild(contentBannedMessage);
                    }
                }

                // Verify that the message is visible. Otherwise add it to body to be sure.
                const width = contentBannedMessage.clientWidth;
                const height = contentBannedMessage.clientHeight;

                if (!width || !height) {
                    contentBannedMessage.parentElement.removeChild(contentBannedMessage);
                    document.body.appendChild(contentBannedMessage);
                }
            }
        },

        updatePlayButton() {
            const playButton = this.domElements.playButton;
            if (playButton) {
                if (!this.videoUrl?.length) {
                    this.hideElement(playButton);
                    return;
                }

                this.isPlayingVideo ? this.hideElement(playButton) : this.showElement(playButton);
                playButton.onclick = this.togglePlay;
            }
        },

        updateRecordButtons() {
            const recordVideoButton = this.domElements.recordVideoButton;
            const editVideoButton = this.domElements.editVideoButton;

            if (recordVideoButton) {
                this.displayRecordButton
                    ? this.showElement(recordVideoButton)
                    : this.hideElement(recordVideoButton);
            }

            if (editVideoButton) {
                this.displayEditButton
                    ? this.showElement(editVideoButton)
                    : this.hideElement(editVideoButton);
            }
        },

        updateShareButton() {
            const shareButton = this.domElements.shareButton;

            if (shareButton) {
                shareButton.onclick = this.share;
                this.displayShareButton
                    ? this.showElement(shareButton)
                    : this.hideElement(shareButton);
            }
        },

        updateDownloadButton() {
            const downloadButton = this.domElements.downloadButton;

            if (downloadButton) {
                downloadButton.onclick = this.downloadVideo;
                this.displayDownloadButton
                    ? this.showElement(downloadButton)
                    : this.hideElement(downloadButton);
            }

            const fullscreenDownloadButton = this.domElements.fullscreenDownloadButton;

            if (fullscreenDownloadButton) {
                fullscreenDownloadButton.onclick = this.downloadVideo;
                this.displayDownloadButton && this.fullscreenEnabled
                    ? this.showElement(fullscreenDownloadButton)
                    : this.hideElement(fullscreenDownloadButton);
            }
        },

        updateARButton() {
            const arButton = this.domElements.arButton;
            if(this.webarUrl){
                this.showElement(arButton);
            }else{
                this.hideElement(arButton);
            }
        },

        updateReportButton() {
            let reportButton = this.domElements.reportButton;

            if (!reportButton && this.displayReportButton) {
                reportButton = document.createElement("a");
                reportButton.innerText = this.$t("report.report");

                if (this.domElements.videoContainer) {
                    reportButton.style.setProperty("color", "white", "important");
                    reportButton.style.setProperty("position", "absolute", "important");
                    reportButton.style.setProperty("top", "20px", "important");
                    reportButton.style.setProperty("left", "20px", "important");
                    reportButton.style.setProperty("text-decoration", "none", "important");

                    this.domElements.videoContainer.appendChild(reportButton);
                } else {
                    reportButton.style.setProperty("color", "var(--screenTextColor)", "important");
                    reportButton.style.setProperty("position", "fixed", "important");
                    reportButton.style.setProperty("bottom", "20px", "important");
                    reportButton.style.setProperty("left", "50%", "important");
                    reportButton.style.setProperty("transform", "translateX(-50%)", "important");

                    document.getElementById("app").appendChild(reportButton);
                }

                this.domElements.reportButton = reportButton;
            }

            if (this.displayReportButton) {
                this.showElement(reportButton);
                reportButton.onclick = () => {
                    this.$emit("report-btn-clicked");
                };
            } else if (reportButton) {
                this.hideElement(reportButton);
                delete reportButton.onclick;
            }
        },

        manageRetroCompatibility() {
            function addInputOnButton(
                button: HTMLElement,
                inputId: string
            ): {
                btn: HTMLElement;
                inp: HTMLInputElement;
            } {
                const parent = button.parentElement;
                const newButton = document.createElement("label");
                newButton.setAttribute("label", inputId);
                newButton.id = button.id;
                newButton.innerHTML = button.innerHTML;
                parent.appendChild(newButton);
                parent.removeChild(button);
                const pickVideoButton = document.createElement("input") as HTMLInputElement;
                pickVideoButton.id = inputId;
                pickVideoButton.style.display = "none";
                pickVideoButton.setAttribute("accept", "video/*");
                pickVideoButton.setAttribute("type", "file");
                newButton.appendChild(pickVideoButton);

                return {
                    btn: newButton,
                    inp: pickVideoButton
                };
            }

            const inputVideoFile = this.domElements.inputVideoFile;
            const recordVideoButton = this.domElements.recordVideoButton;
            if (recordVideoButton && !inputVideoFile) {
                const response = addInputOnButton(recordVideoButton, "videoPick");
                this.domElements.recordVideoButton = response.btn;
                this.domElements.inputVideoFile = response.inp;
            }

            const inputEditVideoFile = this.domElements.inputEditVideoFile;
            const editVideoButton = this.domElements.editVideoButton;
            if (editVideoButton && !inputEditVideoFile) {
                const response = addInputOnButton(editVideoButton, "editVideoPick");
                this.domElements.editVideoButton = response.btn;
                this.domElements.inputEditVideoFile = response.inp;
            }
        }
    },
    watch: {
        adminUrl() {
            this.updateProfileLink();
        },
        videoUrl() {
            this.updateVideo();
        },
        isPlayingVideo() {
            this.updatePlayButton();
        },
        videoReady() {
            this.updateVideoContainer();
        },
        fullscreenEnabled() {
            this.updateVideoContainer();
            // this.updateARButton();
            this.updateDownloadButton();
        },
        displayRecordButton() {
            this.updateRecordButtons();
        },
        displayEditButton() {
            this.updateRecordButtons();
        },
        // displayArButton() {
        //     this.updateARButton();
        // },
        displayShareButton() {
            this.updateShareButton();
        },
        displayDownloadButton() {
            this.updateDownloadButton();
        }
    }
};
</script>
<style scoped>
.home-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
